import React from "react";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";

import { useDispatch, useSelector } from "react-redux";
import {
  layerDetailDeleteHandler,
  layerDetailFetch,
  selectLicenseList,
  setLayerColor,
  setLayerDetails,
  setLayerDetailsLoaded,
} from "../../../api/redux";

export default (props) => {
  const dispatch = useDispatch();
  const state = useSelector(selectLicenseList);

  const onChange = async (e) => {
    const { id, color, marker, title } = props.data;
    if (e.target.checked) {
      dispatch(setLayerDetailsLoaded(false));
      await dispatch(layerDetailFetch({ layerId: id, color, marker }));
      dispatch(
        setLayerColor([
          ...state.layersColor,
          {
            id: state.layersColor.length + 1,
            marker,
            color,
            title,
            layerId: id,
          },
        ])
      );
 
      setTimeout(() => {
        dispatch(setLayerDetailsLoaded(true));
      });
    } else {
      dispatch(setLayerDetailsLoaded(false));

      let filtered = state.layersColor.filter((el) => {
        return el.layerId !== id;
      });
      dispatch(setLayerColor(filtered));
      dispatch(layerDetailDeleteHandler({ layerId: id }));
      setTimeout(() => {
        dispatch(setLayerDetailsLoaded(true));
      });
    }
  };

  return (
    <div className="d-flex flex-wrap accordionChild mb-1">
      <Checkbox onChange={(e) => onChange(e)}>{props.text}</Checkbox>
      {/* <Checkbox onChange={onChange}>حریم شهرها</Checkbox> */}
    </div>
  );
};
